import React, { Component } from "react";
import "./ViewQuery.scss";
import { connect } from "react-redux";
import {
    fetchCreatedQueriesList,
    enableDataFetch,
    disableDataFetch,
    deleteRule,
    changeViewQueryMode,
    changeBulkMode,
    changeCreateQueryActiveTab,
    editQuery,
} from "../../../../../actions/queryBuilderActions";
import { packageUpgradePopup } from "../../../../../actions/globalAction";
import { ReactComponent as EmptyQuery } from "../../../../../assets/svg/empty-query.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { Scrollbars } from "react-custom-scrollbars";
import { getAccessToken } from "../../../../../actions/utils";
import { ReactComponent as SearchIcon } from "../../../../../assets/svg/search.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/svg/add.svg";
import { ReactComponent as CaneclIcon } from "../../../../../assets/svg/close.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/download-queries.svg";
import Topic from "../topics/Topic";
import Select, { components } from "react-select";
import { ReactComponent as FilterImage } from "../../../../../assets/svg/filter.svg";
import moment from "moment";
import { downloadCSVData } from "../../../../../components/MainContent/Dashboard/Charts/utils";
import { ReactComponent as UpIcon } from "../../../../../assets/svg/up-arrow.svg";
import DeleteQueryModal from "../DeleteQuery/DeleteQueryModal";
import { LimitMessage } from "../../../../SubscriptionModule/LimitComponents";
import LocationPopupModal from "./LocationPopupModal";
import { Link } from "react-router-dom";

class ViewQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTextValue: "",
            statusOption: [],
            statusText: "",
            sortBy: "",
            sortDirection: "",
            deleteModalOpen: false,
            queryToBeDeleted: {},
            openLocationPopupModal: false,
        };
    }
    componentDidMount() {
        this.props.fetchCreatedQueriesList();
    }

    topicHashMapCreation = () => {
        const shuffeledTpicData = this.props.queryList;
        const topicnameList = shuffeledTpicData.map((ele) => ele.topic_name);
        const new_array = [];
        topicnameList.forEach((element) => {
            if (!new_array.includes(element)) {
                new_array.push(element);
            }
        });
        const finalTopic = new_array.map((topic) => {
            const obj = {};
            obj["topic"] = topic;
            const subTopicList = shuffeledTpicData.filter((subtopic) => subtopic.topic_name === topic);
            obj["sub_topics"] = subTopicList;
            obj["modified_date"] = subTopicList[0]["modified_date"];
            obj["created_date"] = subTopicList[0]["created_date"];
            return obj;
        });
        // console.log(finalTopic);
        return finalTopic;
    };
    enableDataPull = (elem) => {
        let param = {};
        param["id"] = elem.research_query_id;
        param["access-token"] = getAccessToken();
        this.props.enableDataFetch(param);
    };
    disableDataPull = (elem) => {
        let param = {};
        param["id"] = elem.research_query_id;
        param["access-token"] = getAccessToken();
        this.props.disableDataFetch(param);
    };
    deleteSubtopicWithQuery = (elem) => {
        let param = {};
        param["id"] = elem.subtopic_id;
        param["research_query_id"] = elem.research_query_id;
        this.props.deleteRule(param);
        this.handleClose();
    };
    handleDelete = (elem) => {
        this.setState({ deleteModalOpen: true, queryToBeDeleted: elem });
    };
    handleClose = () => {
        this.setState({ queryToBeDeleted: {}, deleteModalOpen: false });
    };
    handlEditQuery = (elem) => {
        this.props.changeViewQueryMode(false);
        this.props.changeCreateQueryActiveTab(1);
        this.props.changeBulkMode(true);
        setTimeout(() => {
            this.props.editQuery(elem);
        }, 0);
        // this.props.editQuery(elem);
    };
    myStyle = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            background: "#E7E8F0",
            height: "36px",
            minHeight: "36px",
            position: "initial",
            cursor: "pointer",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#E7E8F0" : null, color: "#1F2E3D" };
        },
        valueContainer: (base) => ({ ...base, paddingLeft: "20px" }),
    };
    Control = ({ children, ...props }) => {
        const style = { cursor: "pointer" };
        return (
            <components.Control {...props}>
                <span style={style}>{!!children && <FilterImage style={{ height: "20px", width: "20px", marginTop: "5px", marginRight: "4px" }} />}</span>
                <span className="zzz">{children}</span>
            </components.Control>
        );
    };
    getSortClassNamesFor = (_sortBy) => {
        let sortDirection = this.state.sortDirection;
        let sortBy = this.state.sortBy;
        if (sortDirection === "") {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        } else if (sortDirection === "asc" && sortBy === _sortBy) {
            this.setState({ sortDirection: "desc", sortBy: _sortBy });
        } else if (sortDirection === "asc" && sortBy !== _sortBy) {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        } else if (sortDirection === "desc" && sortBy === _sortBy) {
            this.setState({ sortDirection: "", sortBy: "" });
        } else if (sortDirection === "desc" && sortBy !== _sortBy) {
            this.setState({ sortDirection: "asc", sortBy: _sortBy });
        }
    };
    onSearchTextChange = (ev) => {
        this.setState({ searchTextValue: ev.target.value });
    };
    clearSearchFilter = () => {
        this.setState({ searchTextValue: "" });
    };
    handleCreateMode = () => {
        if (this.props.queryListLoading) return;
        // disabling popup for free package for now
        let totalCount = this.props.packageObj.features.number_of_queries.quota;
        // if (this.props.packageObj.package_code === "free" || (totalCount !== -1 && totalCount <= this.props.queryList.length))
        if (totalCount !== -1 && totalCount <= this.props.queryList.length)
            this.props.packageUpgradePopup({
                name: "Create New Query",
                reason:
                    // this.props.packageObj.package_code === "free"
                    // ? "This is a premium feature."
                    // :
                    `You have used ${this.props.queryList?.length || 0} of ${totalCount} available Queries.`,
                message:
                    this.props.packageObj.package_code === "free"
                        ? "Please upgrade your package to create Queries."
                        : "Please contact the support team if you need more Queries",
                type: this.props.packageObj.package_code === "free" ? null : "contact",
            });
        else this.props.changeViewQueryMode(false);
    };
    onHandleChangeStatus = (ev) => {
        this.setState({ statusOption: ev, statusText: ev.value });
    };
    downloadCreatedQueryData = () => {
        let topicData = [["Topic Name", "Sub Topic", "Boolean", "Countries", "Accounts/Keywords", "FB Comments", "Display Query", "Updated Date"]];
        let queryList = this.topicHashMapCreation();
        queryList.map((topic) => {
            topic.sub_topics.map((item) => {
                let accounts = [];
                let postList = [];
                if (item.accounts) {
                    let tiktokKeyword = "";
                    JSON.parse(item.accounts)?.forEach((obj) => {
                        if (obj?.config_type === "tiktok_account") {
                            accounts.push(
                                JSON.stringify({
                                    account: `tiktok:${obj.query_filter};fetch_comment:0;news_config:0;country:${obj?.location_short_name};entity_sub_type:${obj?.entity_sub_type}`,
                                }),
                            );
                        } else if (obj?.config_type === "tiktok") {
                            if (!tiktokKeyword) tiktokKeyword = obj.query_filter;
                            else tiktokKeyword = tiktokKeyword + " OR " + obj.query_filter;
                            return;
                        } else {
                            try {
                                if (JSON.parse(obj)?.keywords) {
                                    let posts = JSON.parse(obj)?.keywords;
                                    posts.map((post) => postList.push(post.post_url));
                                }
                            } catch (e) {
                                accounts.push(
                                    JSON.stringify({
                                        account: obj.value?.replace(/,/g, ";"),
                                    }),
                                );
                            }
                        }
                    });

                    if (tiktokKeyword) accounts.push(JSON.stringify({ tiktokRule: `Keyword: ${tiktokKeyword}` }));
                }

                accounts = accounts?.join(";");
                postList = postList?.join(";");

                topicData.push([
                    item.topic_name,
                    item.subtopic_name,
                    item.boolean,
                    item.countries?.replace(/,/g, ";"),
                    accounts,
                    postList,
                    item.data_fetch_enabled == 1 ? "No" : "Yes",
                    item.created_date,
                ]);
            });
        });
        downloadCSVData(topicData, "Topic Data");
    };
    statusDeclartion = (elem) => {
        const status = elem.data_fetch_enabled !== 2 ? (!elem.is_historical_tagged && elem.tokenized_details ? "processing" : "active") : "paused";
        return status;
    };
    getCountries = (location) => {
        try {
            let countries = this.props.allLocations || [];
            let countryList = location.trim().split(",");
            let allcountriesName = "";
            for (let i = 0; i < countryList.length; i++) {
                let countryInfo = countries.filter((x) => x.short_name == countryList[i].trim());
                allcountriesName += countryInfo[0].name;
                if (i < countryList.length - 1) {
                    allcountriesName += ", ";
                }
            }
            if (allcountriesName == " ") {
                allcountriesName = "WorldWide";
            }
            return allcountriesName || "WorldWide";
        } catch (e) {
            return "WorldWide";
        }
    };
    searchFilter = () => {
        let statusOption = this.state.statusText || "";
        let searchText = this.state.searchTextValue.trim();
        let sortByColumn = this.state.sortBy;
        let sortDirection = this.state.sortDirection;
        let filterData = [];
        let _viewQueryListData = this.topicHashMapCreation();
        let viewQueryListData = _viewQueryListData;
        if (searchText === "" && sortByColumn === "" && statusOption === "") return _viewQueryListData;

        if (statusOption !== "") {
            if (statusOption === "all") {
                filterData = viewQueryListData;
            } else {
                let statusList = [];
                viewQueryListData.forEach((ele) => {
                    let acc = [];
                    acc = ele.sub_topics.filter((elem) => {
                        return this.statusDeclartion(elem) == statusOption.toLowerCase();
                    });
                    if (acc.length > 0) {
                        statusList.push({ ...ele, sub_topics: acc });
                    }
                });
                filterData = statusList;
            }
            if (searchText === "" && sortByColumn === "") {
                return filterData;
            }
        }
        if (searchText !== "") {
            let filterKeyword = searchText.toLowerCase().trim();
            let datatobeFilterd = statusOption === "" ? viewQueryListData : filterData;
            let textFilterData = [];
            datatobeFilterd.forEach((ele) => {
                let acc = [];
                acc = ele.sub_topics.filter((elem) => {
                    return (
                        elem.subtopic_name.toLowerCase().indexOf(filterKeyword) > -1 ||
                        (elem.boolean || "").toLowerCase().indexOf(filterKeyword) > -1 ||
                        elem.topic_name.toLowerCase().indexOf(filterKeyword) > -1 ||
                        (this.statusDeclartion(elem) || "").toLowerCase().indexOf(filterKeyword) > -1 ||
                        (elem.accounts || "").toLowerCase().indexOf(filterKeyword) > -1 ||
                        this.getCountries(elem.countries).toLowerCase().indexOf(filterKeyword) > -1 ||
                        moment(elem.modified_date).format("YYYY-MM-DD").toLowerCase().indexOf(filterKeyword) > -1
                    );
                });
                if (acc.length > 0) {
                    textFilterData.push({ ...ele, sub_topics: acc });
                }
                filterData = textFilterData;
            });
            if (sortByColumn === "") return filterData;
        }
        //sorting
        if (sortByColumn !== "" && sortDirection !== "") {
            let dataToBeSorted = statusOption !== "" || searchText !== "" ? filterData : viewQueryListData;
            let order = sortDirection === "asc" ? 1 : -1;

            if (sortByColumn == "topic_name") {
                filterData = dataToBeSorted.sort((a, b) => {
                    if (a.topic.toLowerCase() > b.topic.toLowerCase()) {
                        return 1 * order;
                    }
                    if (a.topic.toLowerCase() < b.topic.toLowerCase()) {
                        return -1 * order;
                    }
                    return 0;
                });
            }
            if (sortByColumn == "created_date") {
                let topicWiseSortedData = dataToBeSorted.sort((a, b) => order * (moment(a.created_date) - moment(b.created_date)));
                let sortedList = [];
                topicWiseSortedData.forEach((ele) => {
                    let acc = [];
                    acc = ele.sub_topics.sort((a, b) => {
                        return order * (moment(a.created_date) - moment(b.created_date));
                    });
                    if (acc.length > 0) {
                        sortedList.push({ ...ele, sub_topics: acc });
                    }
                });
                filterData = sortedList;
            }
            return filterData;
        }
    };
    checkQueryLists = (querArr) => {
        // let bool = false;
        querArr.forEach((elements) => {
            elements?.sub_topics?.forEach((list) => {
                if (list?.data_fetch_enabled == 1)
                    //  bool =false;
                    return false;
            });
        });
        return true;
    };

    render() {
        let topicsTableData = this.searchFilter();
        let queries = this.props.queryList.length;
        let queryListLoading = this.props.queryListLoading;
        // let enableWarningPopup = this.checkQueryLists(topicsTableData);
        const activeFilterOptions = [
            { label: "All", value: "all" },
            { label: "Active", value: "Active" },
            { label: "Paused", value: "Paused" },
            { label: "Processing", value: "Processing" },
        ];
        return (
            <div className="viewQuery">
                <p className="header__text">Queries</p>
                <div className="viewQuery__header-block">
                    <div className="header__block-left">
                        <button
                            className="create__query-button qb_step3"
                            title="Click to enable create query mode"
                            onClick={() => {
                                this.handleCreateMode();
                            }}>
                            Create New Query
                            <span>
                                <AddIcon />
                            </span>
                        </button>
                        <span className="download" disabled={topicsTableData.length > 0 || queryListLoading ? false : true}>
                            <DownloadIcon onClick={() => this.downloadCreatedQueryData()} title="Click to Download all Topics data" />
                        </span>
                    </div>
                    {queries !== 0 && (
                        <div className="header__block-right">
                            <div className="viewQuery-search qb_step2">
                                <span>
                                    <SearchIcon />
                                </span>
                                <input type="text" placeholder="Search" onChange={this.onSearchTextChange} value={this.state.searchTextValue} />
                                {this.state.searchTextValue && (
                                    <span className="cancel__wrap">
                                        <span
                                            className="cancel-search"
                                            onClick={() => {
                                                this.clearSearchFilter();
                                            }}>
                                            <CaneclIcon />
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="right-filter-section">
                                <Select
                                    options={activeFilterOptions}
                                    className="status-search"
                                    placeholder="Filter"
                                    value={this.state.statusOption}
                                    onChange={this.onHandleChangeStatus}
                                    styles={this.myStyle}
                                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ValueContainer: this.Control }}
                                    isSearchable={false}
                                />
                            </div>
                        </div>
                    )}
                </div>
                {!this.props.queryListLoading && (
                    <LimitMessage
                        packageObj={this.props.packageObj}
                        message={
                            // this.props.packageObj.package_code === "free"
                            //     ? "In a free package, you can only create data display rule."
                            //     :
                            `You have used ${queries} of ${this.props.packageObj.features.number_of_queries.quota} available Queries.`
                        }
                        // limitReached={this.props.packageObj.package_code === "free"}
                        totalCount={this.props.packageObj.features.number_of_queries.quota}
                        usedCount={queries}
                    />
                )}
                {/* {console.log("checkk", typeof this.props.queryList[0]?.data_fetch_enabled, this.props.queryList[0]?.countries === "")} */}
                {!this.props.queryListLoading &&
                    (this.props.packageObj.package_code === "starter" || this.props.packageObj.package_code === "free") &&
                    this.props.queryList[0]?.data_fetch_enabled === 0 &&
                    this.props.queryList[0]?.countries === "" && (
                        <>
                            {this.props.packageObj.package_code === "free" ? (
                                <p className="warning__data__pull">
                                    You are currently receiving <strong>sample</strong> data in the trial plan. To receive full data, please{" "}
                                    <Link to="/subscription">upgrade your plan</Link>.
                                </p>
                            ) : (
                                <p className="warning__data__pull">
                                    You are on a paid plan but you are currently receiving only <strong>sample</strong> data. To receive full data,{" "}
                                    <span
                                        className="popup__locationModal"
                                        onClick={() => {
                                            this.setState({ openLocationPopupModal: true });
                                        }}>
                                        select countries
                                    </span>{" "}
                                    you are interested in tracking
                                </p>
                            )}
                        </>
                    )}
                <DeleteQueryModal
                    open={this.state.deleteModalOpen}
                    onClose={() => this.setState({ deleteModalOpen: false })}
                    queryToBeDeleted={this.state.queryToBeDeleted}
                    deleteSubtopicWithQuery={this.deleteSubtopicWithQuery}
                    handleClose={this.handleClose}
                />
                {this.state.openLocationPopupModal && (
                    <LocationPopupModal
                        open={this.state.openLocationPopupModal}
                        queryToEdit={this.props.queryList[0]}
                        onCancel={() => this.setState({ openLocationPopupModal: false })}
                    />
                )}
                {queries > 0 && (
                    <>
                        <div className="table__header">
                            <div className="topic_name">
                                Topic
                                <span
                                    title="Sort"
                                    className={`short__persist ${
                                        this.state.sortBy == "topic_name" ? (this.state.sortDirection === "asc" ? "short__rotateUp" : "short__rotateDown") : ""
                                    }`}
                                    onClick={() => this.getSortClassNamesFor("topic_name")}>
                                    {<UpIcon />}
                                </span>
                            </div>
                            <div className="boolean__query">Boolean Query </div>
                            <div className="location">Location </div>
                            <div className="account_name">Accounts/Keywords </div>
                            <div className="posts">FB Comments </div>
                            <div className="added_on">
                                <Popup content="YYYY-MM-DD" trigger={<span>Updated Date </span>} size="mini" position="top center" inverted />
                                <span
                                    title="Sort"
                                    className={`short__persist ${
                                        this.state.sortBy == "created_date"
                                            ? this.state.sortDirection === "asc"
                                                ? "short__rotateUp"
                                                : "short__rotateDown"
                                            : ""
                                    }`}
                                    onClick={() => this.getSortClassNamesFor("created_date")}>
                                    {<UpIcon />}
                                </span>
                            </div>
                            <div className="query_status">Status</div>
                            <span className="delete_query">Data Pull</span>
                            <span className="more__action">More</span>
                        </div>
                        {topicsTableData.length > 0 && (
                            <div className="table__body">
                                <Scrollbars autoHide>
                                    {topicsTableData.map((ele, ind) => {
                                        return (
                                            <Topic
                                                ele={ele}
                                                userTimeZone={this.props.userTimeZone}
                                                key={ele.topic}
                                                disableDataPull={this.disableDataPull}
                                                enableDataPull={this.enableDataPull}
                                                deleteSubtopicWithQuery={this.deleteSubtopicWithQuery}
                                                handlEditQuery={this.handlEditQuery}
                                                allLocations={this.props.allLocations}
                                                handleDelete={this.handleDelete}
                                                packageObj={this.props.packageObj}
                                            />
                                        );
                                    })}
                                </Scrollbars>
                            </div>
                        )}
                    </>
                )}
                {queries === 0 && !queryListLoading && (
                    <div className="no_data-content">
                        <span>
                            <EmptyQuery />
                        </span>
                        <p>
                            <strong>You have not created any data queries yet.</strong>
                        </p>
                        <p>Queries help you fetch relevant data from social networks, Blogs, Forums and new sites.</p>
                        <p>Fortunately, it is very easy to create a Query. Click on the Create New Query button above right.</p>
                    </div>
                )}
                {queryListLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big" className="skiptranslate">
                                Loading
                            </Loader>
                        </Dimmer>
                    </div>
                )}
                {topicsTableData.length == 0 && !queryListLoading && queries !== 0 && <div className="no-data">No Data</div>}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        userTimeZone: state.globalReducer.company.user_timezone_name,
        queryList: state.queryBuilderReducer.createdQueryList.filter((account) => !["competitor", "opa"].includes(account?.config_source?.toLowerCase())),
        queryListLoading: state.queryBuilderReducer.queryListLoading,
        allLocations: state.filterSettingReducer.masterLocations,
        packageObj: state.globalReducer.packageObj,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        fetchCreatedQueriesList: () => dispatch(fetchCreatedQueriesList()),
        enableDataFetch: (data) => dispatch(enableDataFetch(data)),
        disableDataFetch: (data) => dispatch(disableDataFetch(data)),
        deleteRule: (data) => dispatch(deleteRule(data)),
        changeViewQueryMode: (data) => dispatch(changeViewQueryMode(data)),
        changeBulkMode: (data) => dispatch(changeBulkMode(data)),
        changeCreateQueryActiveTab: (data) => dispatch(changeCreateQueryActiveTab(data)),
        editQuery: (data) => dispatch(editQuery(data)),
        packageUpgradePopup: (data) => dispatch(packageUpgradePopup(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewQuery);
